module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./PID.js"));
	}, "PID");
}